import log from 'loglevel';

import {
  TERMINAL_ANONYMOUS_USER_KEY,
  TERMINAL_DEVICE_STORAGE_PREFIX,
} from '../../../utils/constants/terminalConstants';

function storageKey(userId: string | null | undefined): string {
  return `${TERMINAL_DEVICE_STORAGE_PREFIX}${userId ?? TERMINAL_ANONYMOUS_USER_KEY}`;
}

export function readPreferredTerminalDeviceId(
  userId: string | null | undefined,
): string | null {
  try {
    return window.localStorage.getItem(storageKey(userId));
  } catch (error) {
    log.debug('terminalDevicePreference: read failed', error);
    return null;
  }
}

export function storePreferredTerminalDeviceId(
  userId: string | null | undefined,
  deviceId: string | null,
): void {
  try {
    if (deviceId === null) {
      window.localStorage.removeItem(storageKey(userId));
    } else {
      window.localStorage.setItem(storageKey(userId), deviceId);
    }
  } catch (error) {
    log.debug('terminalDevicePreference: write failed', error);
  }
}
